
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/token-town/[...slug]",
      function () {
        return require("private-next-pages/token-town/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/token-town/[...slug]"])
      });
    }
  